import * as THREE from 'three'

export default (points: any, camera: THREE.PerspectiveCamera, dom: THREE.Object3D[], onClick: Function[] = [() => {}]) => {
  const raycast = new THREE.Raycaster()
  return () => {
    let p = points
    
    
    p.y-=window.scrollY
    
    raycast.setFromCamera(p, camera)

    const intersects = raycast.intersectObjects(dom, true)
    
    const res =  intersects.length ? intersects[0].object : null


    onClick.forEach(f => f(res))
    return res
  }  
}